module.exports = __webpack_public_path__ + "static/img/barque.9dc8870.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/barque.png
// module id = 1JAO
// module chunks = 1